import * as React from 'react';
import { connect } from 'react-redux';
import { Accordion, Card, Image } from 'react-bootstrap';
import './Policy.css';
import { PERSONAL_INSURANCE, LIFE_INSURANCE } from '../../routes/routes';
import { setSelectedPersonalPolicy } from '../../actions/profileActions';
import { navigateTo } from '../../actions/navigationActions';

class Policy extends React.Component<any, any> {

    constructor(props) {
       super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleSelectPersonalPolicy = this.handleSelectPersonalPolicy.bind(this);
    }

    async handleSelectPersonalPolicy(destination, policy) {
        if (policy !== undefined && this.props.profile.selectedPersonalPolicy.id !== policy.id) {
            await this.props.handleSetSelectedPersonalPolicy(policy);
        }
        this.props.redirectTo(destination);
    }

    handleRedirect(destination) {

        this.props.redirectTo(destination);
    }

    public render() {
        const { profile } = this.props;
        let count = 0;

        let policyCardsDesktop = this.props.profile.personalPolicies.map((policy) => {
            let id = count;
            count = count + 1;
            return <Card key={policy.id} className="tile mb-lg-3">
                <Accordion.Toggle as={Card.Header} eventKey={id + ""} onClick={() => this.handleSelectPersonalPolicy(PERSONAL_INSURANCE, this.props.profile.personalPolicies[id])}>
                    <div className="row">
                        <div className="col-lg-4 pr-0">
                            <Image src="./Images/icon-personal-insurance.svg" />
                        </div>
                        <div className="col-lg-6 pl-0">
                            <label className="cursor-pointer label mb-0">Personal</label>
                            <br />
                            <span className="policyNumber">{policy !== undefined && policy.policyNumber}</span>
                        </div>
                        <div className="col-lg-2 pr-0">
                            <Image src="./Images/RequestDocuments/icons-arrow-dropdown-right-grey.png" />
                        </div>
                    </div>
                    <hr className="profile-divider-full" />
                    <div >
                        <div className="row">
                            <label className="policyNumber mb-0 col-12">Next debit date</label>
                            <br />
                            <p className="debitDate col-12">{policy !== undefined && policy.nextDebitOrderDate}</p>
                        </div>
                        <div className="row pr-0">
                            <label className="policyNumber mb-0 col-12">Premium</label>
                            <br />
                            <p className="ActivePolicies col-12">{this.props.profile.currencySymbol}{policy !== undefined && policy.totalPolicyPremium} pm</p>
                        </div>
                    </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                    <Card.Body>
                        <div className="row">
                            <div className="col-lg-6 pr-0">
                                <label className="policyNumber mb-0">No. of policies</label>
                                <br />
                                <p className="ActivePolicies">{profile.activePolicies} Active</p>
                            </div>
                            <div className="col-lg-6 p-0">
                                <label className="policyNumber mb-0">Next debit date</label>
                                <p className="debitDate">{policy !== undefined && policy.nextDebitOrderDate}</p>
                            </div>
                        </div>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        });

        count = 0;
        let policyCardsMobile = this.props.profile.personalPolicies.map((policy) => {
            let id = count;
            count = count + 1;
            return <div key={policy.id} className="col-12" onClick={() => this.handleSelectPersonalPolicy(PERSONAL_INSURANCE, this.props.profile.personalPolicies[id])}>
                <div className="tile-mobile-policy">
                    <div className="text-center">
                        <div className="pt-3">
                            <Image src="./Images/icon-personal-insurance.svg" />
                        </div>
                        <div className="pt-2 pb-3">
                            <p className="mb-0 pb-1"><b>Personal</b></p>
                            <span className="policyNumber">{policy !== undefined && policy.policyNumber}</span>
                        </div>
                    </div>
                </div>
            </div>
        });
        return (
            <div>
                <div className="pb-lg-3 d-none d-lg-block d-md-none" id="DesktopView">
                    <Accordion className="policy-card">
                        <div id="AllPersonalPolicies">
                            {policyCardsDesktop}
                        </div>
                        <Card className="tile mb-lg-3 invisible">
                            <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => this.handleRedirect(LIFE_INSURANCE)}>
                                <div className="row">
                                    <div className="col-4 pr-0">
                                        <Image src="./Images/icon-life-insurance.svg" />
                                    </div>
                                    <div className="col-8 pl-0">
                                        <label className="label mb-0">Life</label><br />
                                        <span className="policyNumber">{this.props.profile.lifePolicyNumber}</span>
                                    </div>
                                </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="1">
                                <Card.Body>Life Policy: {this.props.profile.lifePolicyNumber}</Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className="tile mb-lg-3 d-none">
                            <Accordion.Toggle as={Card.Header} eventKey="2">
                                <div className="row">
                                    <div className="col-4 pr-0">
                                        <Image src="./Images/icon-funeral-insurance.svg" />
                                    </div>
                                    <div className="col-8 pl-0">
                                        <label className="label mb-0">Funeral</label><br />
                                        <span className="policyNumber">{profile.funeralPolicyNumber}</span>
                                    </div>
                                </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="2">
                                <Card.Body></Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </div>
                <div className="d-block d-lg-none d-md-block" id="MobileView">
                    <div className="row width">
                        {policyCardsMobile}
                        <div className="col-4 d-none">
                            <div className="tile-mobile-policy">
                                <div className="text-center">
                                    <div className="py-3">
                                        <Image src="./Images/icon-life-insurance.svg" />
                                    </div>
                                    <p className="title">Life</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-4 d-none">
                            <div className="tile-mobile-policy">
                                <div className="text-center">
                                    <div className="py-3">
                                        <Image src="./Images/icon-funeral-insurance.svg" />
                                    </div>
                                    <p className="title">Funeral</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        handleSetSelectedPersonalPolicy: async (policy) => await dispatch(setSelectedPersonalPolicy(policy))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Policy);
